import { connect, useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { getNumeroFinanciero } from "../../../actions/configuracion";
import { getNumeroComercial } from "../../../actions/configuracion";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import colores from "../../../shared/constants/styles";

interface ConfirmacionTiendaProps {
  open: boolean;
  handleClose: () => void;
  successNumeroFinanciero: any;
  successNumeroComercial: any;
  numeroFinanciero: any;
  numeroComercial: any;
}

const DialogWhatsapp = (props: ConfirmacionTiendaProps) => {
  const dispatch = useDispatch();
  const [numeroComercial, setNumeroComercial] = useState("");
  const [numeroFinanciero, setNumeroFinanciero] = useState("");

  const handleRefWhatsappUno = () => {
    const href = `https://api.whatsapp.com/send?phone=${numeroComercial}`;
    window.open(href, "_blank");
  };

  const handleRefWhatsappDos = () => {
    const href = `https://api.whatsapp.com/send?phone=${numeroFinanciero}`;
    window.open(href, "_blank");
  };

  useEffect(() => {
    dispatch(getNumeroComercial());
    dispatch(getNumeroFinanciero());
  }, []);

  useEffect(() => {
    if (props.successNumeroFinanciero) {
      setNumeroFinanciero(props.numeroFinanciero);
    }
  }, [props.successNumeroFinanciero]);

  useEffect(() => {
    if (props.successNumeroComercial) {
      setNumeroComercial(props.numeroComercial);
    }
  }, [props.successNumeroComercial]);

  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Com qual vendedor você deseja entrar em contato?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box display="flex" flexDirection="column" gap={2}>
            {/* Primer ícono */}
            <Box display="flex" alignItems="center" gap={1}>
              <IconButton
                aria-label="whatsapp"
                style={{ fontSize: "40px", background: "#ebebeb" }}
                onClick={handleRefWhatsappDos}
              >
                <WhatsAppIcon
                  style={{ fontSize: "inherit", color: "#00A884" }}
                />
              </IconButton>
              <Typography variant="body1">
                Converse com Financeiro no WhatsApp {numeroFinanciero}
              </Typography>
            </Box>
            {/* Segundo ícono */}
            <Box display="flex" alignItems="center" gap={1}>
              <IconButton
                aria-label="whatsapp"
                style={{ fontSize: "40px", background: "#ebebeb" }}
                onClick={handleRefWhatsappUno}
              >
                <WhatsAppIcon
                  style={{ fontSize: "inherit", color: "#00A884" }}
                />
              </IconButton>
              <Typography variant="body1">
                Converse com Comercial no WhatsApp {numeroComercial}
              </Typography>
            </Box>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button
          className="btn btn-danger"
          type="button"
          onClick={props.handleClose}
          style={{
            backgroundColor: colores.grisOscuro,
            borderColor: colores.grisOscuro,
            padding: "0.625rem",
            marginTop: "1.25rem",
            inlineSize: "10rem",
          }}
        >
          Voltar
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(
  (state: any) => ({
    successNumeroFinanciero: state.configuracion.successNumeroFinanciero,
    successNumeroComercial: state.configuracion.successNumeroComercial,
    numeroComercial: state.configuracion.numeroComercial,
    numeroFinanciero: state.configuracion.numeroFinanciero,
  }),
  (dispatch) => ({
    getNumeroComercial: () => dispatch(getNumeroComercial()),
    getNumeroFinanciero: () => dispatch(getNumeroFinanciero()),
  }),
)(DialogWhatsapp);
